/* FAB-NUKE-20260919 */
/* CHATLOG-LEAD-20261021 */
/**
 * OnlyPlanks Price Q&A chatbot (PDP + sitewide floating widget)
 * API: window.OP_PRICE_QA_API
 * Reads visible page prices / data-op attributes. Never invents MAP prices.
 * Does not block Add to cart.
 */
(function () {
  'use strict';

  var API =
    (typeof window !== 'undefined' && window.OP_PRICE_QA_API) ||
    'https://onlyplanks-price-qa.richard-b94.workers.dev';

  var ROOT_ID = 'op-qa-root';

  function lsGet(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function getSid() {
    var s = lsGet('op_qa_sid');
    if (!s) {
      s = 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      lsSet('op_qa_sid', s);
    }
    return s;
  }
  function getLead() {
    var e = lsGet('op_qa_lead_email');
    return e ? { name: lsGet('op_qa_lead_name'), email: e } : null;
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function linkify(text) {
    var safe = esc(text);
    return safe.replace(
      /(https?:\/\/[^\s<]+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
    ).replace(
      /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
      '<a href="mailto:$1">$1</a>'
    );
  }

  function isProductPage() {
    return /\/products\//.test(location.pathname || '');
  }

  function productHandle() {
    var path = (location.pathname || '').replace(/\/+$/, '');
    var m = path.match(/\/products\/([^/?#]+)/);
    if (m) return decodeURIComponent(m[1]);
    return '';
  }

  function productTitle() {
    var h1 = document.querySelector('h1.product-title, h1.product__title, .product-information h1, main h1');
    if (h1 && h1.textContent) return h1.textContent.trim().slice(0, 160);
    return document.title ? String(document.title).split('|')[0].trim().slice(0, 160) : '';
  }

  function quoteUrl() {
    var u = '/pages/get-best-price';
    try {
      var h = productHandle();
      var t = isProductPage() ? productTitle() : '';
      if (t) u += '?product=' + encodeURIComponent(t) + (h ? '&handle=' + encodeURIComponent(h) : '');
    } catch (e) {}
    return u;
  }

  function fallbackHtml(lead) {
    return (
      esc(lead) +
      ' <a class="op-qa__quote-link" href="' + quoteUrl() + '">Get your best price</a>' +
      ' or email <a href="mailto:contactus@onlyplanks.com.au">contactus@onlyplanks.com.au</a>. We aim to reply the same business day.'
    );
  }

  function isMapHide() {
    return !!(document.body && document.body.classList.contains('op-map-hide'));
  }

  function isMapUnlocked() {
    try {
      if (document.documentElement.classList.contains('op-map-unlocked')) return true;
      if (document.body && document.body.classList.contains('op-map-unlocked')) return true;
      if (document.cookie && /(^|;\s*)op_map_unlock=1(;|$)/.test(document.cookie)) return true;
      if (window.localStorage && localStorage.getItem('op_map_unlock') === '1') return true;
    } catch (e) {}
    return false;
  }

  function readNumAttr(el, names) {
    if (!el) return null;
    for (var i = 0; i < names.length; i++) {
      var raw = el.getAttribute(names[i]);
      if (raw != null && String(raw).trim() !== '') {
        var n = Number(String(raw).replace(/[^0-9.]/g, ''));
        if (!isNaN(n) && n > 0) return n;
      }
    }
    return null;
  }

  function gatherContext() {
    var mapHide = isMapHide();
    var unlocked = isMapUnlocked();
    var boxPrice = null;
    var pricePerM2 = null;
    var priceText = '';

    // Prefer explicit OnlyPlanks data attributes
    var dual = document.querySelector('.op-price-dual, [data-op-price-per-box], [data-price-per-box]');
    boxPrice = readNumAttr(dual, ['data-op-price-per-box', 'data-price-per-box']);
    var buy = document.querySelector('[data-price-per-box]');
    if (boxPrice == null) boxPrice = readNumAttr(buy, ['data-price-per-box']);

    try {
      if (window.OP_MAP_PPM2 != null && window.OP_MAP_PPM2 !== '') {
        var w = Number(window.OP_MAP_PPM2);
        if (!isNaN(w) && w > 0) pricePerM2 = w;
      }
    } catch (e) {}
    if (pricePerM2 == null && document.body) {
      pricePerM2 = readNumAttr(document.body, ['data-op-map-ppm2']);
    }

    // Visible Shopify price text only when MAP is not hiding
    if (!(mapHide && !unlocked)) {
      var priceEl = document.querySelector(
        '.product-information .price, .product-details .price, product-price, .price__regular .price-item--regular, .price-item--regular'
      );
      if (priceEl && priceEl.textContent) {
        priceText = priceEl.textContent.replace(/\s+/g, ' ').trim().slice(0, 80);
      }
      // If no box attr, try parse from dual line
      var boxLine = document.querySelector('.op-box-price-line, .op-box-sell--buy');
      if (boxPrice == null && boxLine && boxLine.textContent) {
        var m = boxLine.textContent.match(/\$\s*([0-9]+(?:\.[0-9]+)?)/);
        if (m) boxPrice = Number(m[1]);
      }
    }

    return {
      handle: productHandle(),
      title: productTitle(),
      mapHide: mapHide,
      mapUnlocked: unlocked,
      priceVisible: !(mapHide && !unlocked) && !!(boxPrice || pricePerM2 || priceText),
      priceText: mapHide && !unlocked ? '' : priceText,
      pricePerM2: mapHide && !unlocked ? '' : pricePerM2 != null ? String(pricePerM2) : '',
      boxPrice: mapHide && !unlocked ? '' : boxPrice != null ? String(boxPrice) : '',
      pageType: isProductPage() ? 'product' : 'other',
    };
  }

  function buildUI() {
    if (document.getElementById(ROOT_ID)) return;

    var root = document.createElement('div');
    root.id = ROOT_ID;
    root.className = 'op-qa';
    root.setAttribute('data-op-qa', '1');
    root.innerHTML =
      '<button type="button" class="op-qa__fab" aria-expanded="false" aria-controls="op-qa-panel" title="Ask about price &amp; freight">' +
      '<span class="op-qa__fab-icon" aria-hidden="true">?</span>' +
      '<span class="op-qa__fab-label">Ask us</span>' +
      '</button>' +
      '<div id="op-qa-panel" class="op-qa__panel" role="dialog" aria-label="OnlyPlanks price and freight helper" hidden>' +
      '  <div class="op-qa__header">' +
      '    <div class="op-qa__header-text">' +
      '      <strong>Price &amp; freight help</strong>' +
      '      <span class="op-qa__sub">Friendly answers. Email if we are stuck. Same business day aim.</span>' +
      '    </div>' +
      '    <button type="button" class="op-qa__close" aria-label="Close help">×</button>' +
      '  </div>' +
      '  <div class="op-qa__messages" id="op-qa-messages" aria-live="polite"></div>' +
      '  <div class="op-qa__chips" id="op-qa-chips"></div>' +
      '  <form class="op-qa__form" id="op-qa-form" autocomplete="off">' +
      '    <label class="visually-hidden" for="op-qa-input">Your question</label>' +
      '    <input id="op-qa-input" class="op-qa__input" type="text" maxlength="500" placeholder="Ask about price, Collect, freight…" />' +
      '    <button type="submit" class="op-qa__send">Send</button>' +
      '  </form>' +
      '  <p class="op-qa__foot">Stuck? <a class="op-qa__quote-link" href="' + quoteUrl() + '">Get your best price</a> · <a href="mailto:contactus@onlyplanks.com.au">contactus@onlyplanks.com.au</a> · same business day aim</p>' +
      '</div>';

    document.body.appendChild(root);

    var fab = root.querySelector('.op-qa__fab');
    var panel = root.querySelector('.op-qa__panel');
    var closeBtn = root.querySelector('.op-qa__close');
    var form = root.querySelector('#op-qa-form');
    var input = root.querySelector('#op-qa-input');
    var messages = root.querySelector('#op-qa-messages');
    var chipsEl = root.querySelector('#op-qa-chips');

    var fabSlot = fab.parentNode;
    function hideChrome(on) {
      try {
        document.body.classList.toggle('op-qa-open', !!on);
        document.documentElement.classList.toggle('op-qa-open', !!on);
      } catch (e) {}
      // Nuke FAB from DOM while open (CSS alone failed on iOS Safari)
      if (on) {
        if (fab.parentNode) fab.parentNode.removeChild(fab);
      } else if (fabSlot && !fab.parentNode) {
        fabSlot.insertBefore(fab, fabSlot.firstChild);
      }
      // Hide Google Customer Reviews / merchant badge while chat open
      try {
        var nodes = document.querySelectorAll(
          '#gcr-badge, .gcr-badge, iframe[src*="google.com/shopping"], iframe[src*="merchantwidget"], [id*="merchantwidget"], [class*="merchantwidget"]'
        );
        for (var i = 0; i < nodes.length; i++) {
          if (on) {
            if (!nodes[i].dataset.opQaPrevVis) {
              nodes[i].dataset.opQaPrevVis = nodes[i].style.visibility || '';
              nodes[i].dataset.opQaPrevDisp = nodes[i].style.display || '';
            }
            nodes[i].style.setProperty('display', 'none', 'important');
            nodes[i].style.setProperty('visibility', 'hidden', 'important');
          } else if (nodes[i].dataset.opQaPrevVis !== undefined) {
            nodes[i].style.display = nodes[i].dataset.opQaPrevDisp;
            nodes[i].style.visibility = nodes[i].dataset.opQaPrevVis;
          }
        }
      } catch (e) {}
    }
    function setOpen(open) {
      if (open) {
        panel.hidden = false;
        try {
          panel.style.removeProperty('display');
        } catch (e) {
          panel.style.display = '';
        }
        root.classList.add('op-qa--open');
        hideChrome(true);
        fab.setAttribute('aria-expanded', 'true');
        fab.setAttribute('aria-hidden', 'true');
        fab.hidden = true;
        fab.tabIndex = -1;
        setTimeout(function () {
          try {
            input.focus();
          } catch (e) {}
        }, 50);
      } else {
        panel.hidden = true;
        try {
          panel.style.setProperty('display', 'none', 'important');
        } catch (e) {
          panel.style.display = 'none';
        }
        root.classList.remove('op-qa--open');
        hideChrome(false);
        fab.setAttribute('aria-expanded', 'false');
        fab.removeAttribute('aria-hidden');
        fab.hidden = false;
        try {
          fab.style.removeProperty('display');
        } catch (e) {
          fab.style.display = '';
        }
        fab.tabIndex = 0;
      }
    }

    fab.addEventListener('click', function () {
      setOpen(panel.hidden);
    });
    closeBtn.addEventListener('click', function () {
      setOpen(false);
      try { fab.focus(); } catch (e) {}
    });
    // Escape closes the helper (SimGym 4 Oct 2026: close must always work)
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) && !panel.hidden) {
        setOpen(false);
        try { fab.focus(); } catch (e2) {}
      }
    });
    // Click on the dimmed backdrop (outside the panel) closes it
    root.addEventListener('click', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && e.target !== fab && !fab.contains(e.target)) {
        setOpen(false);
      }
    });

    // Always start closed — never auto-pop
    try {
      setOpen(false);
      panel.hidden = true;
      panel.style.setProperty('display', 'none', 'important');
      root.classList.remove('op-qa--open');
      document.body.classList.remove('op-qa-open');
      document.documentElement.classList.remove('op-qa-open');
    } catch (e) {}


    function addBubble(role, html) {
      var div = document.createElement('div');
      div.className = 'op-qa__msg op-qa__msg--' + role;
      div.innerHTML = html;
      messages.appendChild(div);
      messages.scrollTop = messages.scrollHeight;
    }

    function setChips(list) {
      chipsEl.innerHTML = '';
      (list || []).forEach(function (label) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'op-qa__chip';
        b.textContent = label;
        b.addEventListener('click', function () {
          input.value = label;
          ask(label);
        });
        chipsEl.appendChild(b);
      });
    }

    var answered = 0;
    var leadAsked = false;
    function maybeAskLead(reason) {
      if (leadAsked || getLead() || lsGet('op_qa_lead_skip') === '1') return;
      leadAsked = true;
      var wrap = document.createElement('div');
      wrap.className = 'op-qa__msg op-qa__msg--bot op-qa__lead';
      wrap.innerHTML =
        '<p>' + esc(reason === 'escalate'
          ? 'Happy to have the team follow this up for you. Pop your name and email in and we will get back to you, usually the same business day.'
          : 'Want us to email you the details so you have them handy? Leave your name and email and we will follow up.') + '</p>' +
        '<form class="op-qa__lead-form" autocomplete="on">' +
        '<input class="op-qa__input" name="name" type="text" maxlength="120" placeholder="Your name" autocomplete="name" />' +
        '<input class="op-qa__input" name="email" type="email" maxlength="200" placeholder="Your email" autocomplete="email" required />' +
        '<div style="display:flex;gap:8px;margin-top:6px">' +
        '<button type="submit" class="op-qa__send">Send</button>' +
        '<button type="button" class="op-qa__chip op-qa__lead-skip">No thanks</button></div>' +
        '</form>';
      messages.appendChild(wrap);
      messages.scrollTop = messages.scrollHeight;
      var lf = wrap.querySelector('form');
      wrap.querySelector('.op-qa__lead-skip').addEventListener('click', function () {
        lsSet('op_qa_lead_skip', '1');
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
      });
      lf.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = String(lf.elements.name.value || '').trim();
        var email = String(lf.elements.email.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(email)) {
          lf.elements.email.focus();
          return;
        }
        fetch(API.replace(/\/$/, '') + '/v1/lead', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ name: name, email: email, sid: getSid(), reason: reason, consent: true,
            page: String(location.href || '').split('#')[0].slice(0, 300) }),
          credentials: 'omit',
          mode: 'cors',
        }).catch(function () {});
        lsSet('op_qa_lead_email', email);
        lsSet('op_qa_lead_name', name);
        wrap.innerHTML = '<p>' + esc('Thanks' + (name ? ' ' + name.split(' ')[0] : '') + '! We will be in touch at ' + email + '.') + '</p>';
      });
    }

    var busy = false;
    var ASK_TIMEOUT_MS = 12000;
    var SLOW_NOTE_MS = 6000;
    function ask(text) {
      var q = String(text || '').trim();
      if (!q || busy) return;
      busy = true;
      addBubble('user', esc(q));
      input.value = '';
      addBubble('bot', '<span class="op-qa__thinking">Thinking…</span>');
      var thinking = messages.lastChild;
      var finished = false;
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;

      function done(html) {
        if (finished) return;
        finished = true;
        clearTimeout(slowTimer);
        clearTimeout(hardTimer);
        busy = false;
        if (thinking && thinking.parentNode) thinking.parentNode.removeChild(thinking);
        addBubble('bot', html);
      }

      // After a few seconds show the friendly route so nobody is left staring at "Thinking…"
      var slowTimer = setTimeout(function () {
        if (finished || !thinking) return;
        thinking.innerHTML =
          '<span class="op-qa__thinking">Still thinking… this can take a few seconds. ' +
          'Or <a class="op-qa__quote-link" href="' + quoteUrl() + '">get your best price</a> directly.</span>';
      }, SLOW_NOTE_MS);

      // Hard stop: give up after 12s, always unblock the box and show a friendly fallback
      var hardTimer = setTimeout(function () {
        if (finished) return;
        try { if (ctrl) ctrl.abort(); } catch (e) {}
        done(fallbackHtml('Sorry, that is taking longer than it should.'));
      }, ASK_TIMEOUT_MS);

      var payload = {
        message: q,
        context: gatherContext(),
        sid: getSid(),
        page: String(location.href || '').split('#')[0].slice(0, 300),
      };
      var knownLead = getLead();
      if (knownLead) payload.lead = knownLead;

      var opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'omit',
        mode: 'cors',
      };
      if (ctrl) opts.signal = ctrl.signal;

      var req;
      try {
        req = fetch(API.replace(/\/$/, '') + '/v1/ask', opts);
      } catch (e) {
        done(fallbackHtml('I could not reach the helper just now.'));
        return;
      }
      req
        .then(function (r) {
          return r.json().then(function (j) {
            return { ok: r.ok, j: j };
          });
        })
        .then(function (res) {
          if (res.ok && res.j && res.j.answer) {
            done(linkify(res.j.answer));
            if (res.j.chips) setChips(res.j.chips);
            answered++;
            if (res.j.escalate) maybeAskLead('escalate');
            else if (answered >= 2) maybeAskLead('after_2');
          } else {
            done(fallbackHtml('Something went wrong on my side.'));
          }
        })
        .catch(function () {
          done(fallbackHtml('I could not reach the helper just now.'));
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      ask(input.value);
    });

    // Welcome
    addBubble(
      'bot',
      linkify(
        'Hi! Ask about warehouse pricing, Collect, freight, MAP unlock, Trade, or returns. I read prices from this page when they are visible. I will not invent a price. Stuck? Email contactus@onlyplanks.com.au. We aim to reply the same business day.'
      )
    );
    setChips([
      'How much does this cost?',
      'Is Collect free?',
      'What about freight?',
      'Can my installer collect?',
      'Trade Unlock?',
      'Returns?',
    ]);
  }

  ready(function () {
    try {
      buildUI();
    } catch (e) {
      try {
        console.warn('[OnlyPlanks QA]', e);
      } catch (e2) {}
    }
  });
})();
